import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../style/Home.css";
import Encabezado from "../../components/Encabezado";
import Footer from "../../components/Footer/Footer";
import Video from "../../components/Body/Video";
import StoriesFast from "../../components/Body/StoriesFast";
import Checked from "../../components/Body/Checked";
import Compartir from "../../components/Body/Compartir";
import Cobrar from "../../components/Body/Cobrar";
import Final from "../../components/Body/Final";
import Questions from "../../components/Form/Questions";
import { APIfetchApi } from "../../utils/APIfetchApi";
import { useAppContext } from "../../AppContext";
import ShortUniqueId from "short-unique-id";

export default function Home() {
  const objectToSearch = (obj) => {
    const keyValuePairs = [];
    
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = encodeURIComponent(obj[key]);
        const encodedKey = encodeURIComponent(key);
        keyValuePairs.push(`${encodedKey}=${value}`);
      }
    }
    
    return keyValuePairs.join('&');
  };
  const searchToObject = () => {
    var pairs = window.location.search.substring(1).split("&"),
      obj = {},
      pair,
      i;

    for (i in pairs) {
      if (pairs[i] === "") continue;
      pair = pairs[i].split("=");
      obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    return obj;
  };
  let utms = searchToObject();
  delete utms.p;
  const params = useParams();

  const queryParameters = new URLSearchParams(window.location.search);
  let spot = {};
  if(queryParameters.get("p") !== null){
    spot = JSON.parse(atob(queryParameters.get("p")));
    
  }

  const { globalState, setGlobalState } = useAppContext({});

  const ENDPOINT = process.env.REACT_APP_URL_BASE;
  const APIKEY = process.env.APIKEY;
  const TOKEN = process.env.REACT_APP_TOKEN;

  const fetchApi = new APIfetchApi();
  let headerConsulta = new Headers();
  headerConsulta.append("Access-Control-Allow-Origin", "*");
  headerConsulta.append("Access-Control-Allow-Headers", "*");
  headerConsulta.append("Content-Type", "application/json");
  headerConsulta.append("apiKey", APIKEY);
  headerConsulta.append("token", TOKEN);

  const handleInit = async () => {
    const consultStatus = await fetchApi.fetchApi(
      headerConsulta,
      "GET",
      undefined,
      ENDPOINT + "/study/" + params.id
    );
    const info = await consultStatus.json();
    let images = [];
    info[0].items.map((e) => {
      if (e.type === "image_choice_single" || e.type === "image_choice_multiple") {
        images = e.urls;
      }
      return e;
    });
    console.log(images);

    let stud = info[0].displayName.split("-");

    const uid = new ShortUniqueId({ length: 8 });
    setGlobalState(
      await {
        ...globalState,
        shortUuid: spot.r !== undefined ? spot.r : uid(),
        studyId: params.id,
        questions: info[0].items,
        allQuestions: info[0].items,
        vimeo: stud[0],
        title: info[0].name,
        descripcionVideo: info[0].cover,
        step: "1",
        images: images,
        referrer: spot.r,
        finalMessage: info[0].finalMessage,
        amount: stud[1],
        phoneNumber: "",
        utms,
        urlUtms:"&"+objectToSearch(utms),
        whatsapp:spot.w === undefined ? info[0].whatsapp : spot.w === false ? false : info[0].whatsapp,
        noRepeat:false,
        finvimeo:false
      }
    );
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Encabezado />
      {globalState.step === "1" ? (
        <Video />
      ) : globalState.step === "2" ? (
        <StoriesFast />
      ) : globalState.step === "3" ? (
        <Questions />
      ) : globalState.step === "4" ? (
        <Cobrar />
      ) : globalState.step === "6" ? (
        <Compartir />
      ) : (
        <Final />
      )}
      {globalState.aditionalNavbar && globalState.step !== "3" && <Footer />}
    </>
  );
}
